<template>
    <div :class="sectionClass">
        <v-row style="" class="black-transparent-up home-section">

            <v-col cols="12" sm="2" md="2" lg="3"  :class="sectionClass"
                   class="px-0 px-md-5 mx-auto before-md-text-center md-text-right d-none d-sm-block">
                <span class="puce-num">
                    <span class="font-oxa font-large2">{{ sectionInx }}</span>
                </span>
            </v-col>
            <v-col cols="12" sm="10" md="9" lg="7" class="px-3 px-md-5 text-left blterm">
                <span class="puce-num d-sm-none">
                    <span class="font-oxa font-large2">{{ sectionInx }}</span>
                </span>
                <v-btn small fab color="#fbc02d" class="black--text d-sm-none mb-4 ml-3"
                        @click="restart()">
                    <v-icon>mdi-play</v-icon>
                </v-btn> 
                <slot :sectionInx="sectionInx" :sectionClass="sectionClass"></slot>
            </v-col>
            <v-col cols="12" sm="0" md="1" lg="1" class="d-none d-md-flex mr-auto"></v-col>

        </v-row>
    </div>
  </template>
  
  <script>

  export default {
    name: 'TypingSection',
    props: ['sectionInx'],
    data: () => ({
        sectionClass: ""
    }),
    // setup() {
    //     provide('parentData', {
    //         sectionInx: this.sectionInx
    //     })
    //     console.log("parentData provided", this.sectionInx)
    // },
    mounted() {
        
        //this.startTyping()
        if(this.sectionInx > 1)
        this.sectionClass = "d-none"

        this.$root.$on('startNextTyping', (newTxtInx) => { 
            if((this.sectionInx*10) > newTxtInx){
                if(((this.sectionInx-1)*10) > newTxtInx)
                    this.sectionClass = "d-none"
                else
                setTimeout(() => { this.sectionClass = "mb-10" }, 2000) 
            }

        })
    },
    beforeDestroy() {
        
    },
    methods: {
        restart() {
            console.log("restart", this.txtInxLo)
            this.$root.$emit("startNextTyping", (this.sectionInx*10)+1)
        },
    },
    computed: {
        
    }
  }
  </script>
  